import ButtonCellSchevronOptionComponent from "./ButtonCellSchevronOption";
import {
    Label,
    Subtitle,
    Value,
} from "./components/Base/ButtonCellSchevronOptionBase";
import BottomAddon from "./components/BottomAddon/ButtonCellSchevronOptionBottomAddon";
import {
    FirstInlineButton,
    SecondInlineButton,
} from "./components/BottomInlineButton/ButtonCellSchevronOptionBottomInlineButton";
import ButtonInlineCounter from "./components/BottomInlineButton/Counter/ButtonCellSchevronOptionButtonInlineCounter";
import {
    ButtonInlineLeftIcon,
    ButtonInlineRightIcon,
} from "./components/BottomInlineButton/Icon/ButtonCellSchevronOptionButtonInlineIcon";
import ButtonInlineLabel from "./components/BottomInlineButton/Label/ButtonCellSchevronOptionButtonInlineLabel";
import LeftIcon from "./components/LeftIcon/ButtonCellSchevronOptionLeftIcon";

export interface IButtonCellSchevronOptionExtensions {
    Label: typeof Label;
    Subtitle: typeof Subtitle;
    Value: typeof Value;
    LeftIcon: typeof LeftIcon;
    BottomAddon: typeof BottomAddon;
    FirstInlineButton: typeof FirstInlineButton;
    SecondInlineButton: typeof SecondInlineButton;
    ButtonInlineLabel: typeof ButtonInlineLabel;
    ButtonInlineCounter: typeof ButtonInlineCounter;
    ButtonInlineLeftIcon: typeof ButtonInlineLeftIcon;
    ButtonInlineRightIcon: typeof ButtonInlineRightIcon;
}

export const ButtonCellSchevronOption: typeof ButtonCellSchevronOptionComponent &
    IButtonCellSchevronOptionExtensions = Object.assign(
    ButtonCellSchevronOptionComponent,
    {
        Label,
        Subtitle,
        Value,
        LeftIcon,
        BottomAddon,
        FirstInlineButton,
        SecondInlineButton,
        ButtonInlineLabel,
        ButtonInlineCounter,
        ButtonInlineLeftIcon,
        ButtonInlineRightIcon,
    },
);
